<template>
  <el-form
    ref="form"
    class="authorize-product-form"
    :label-position="labelPosition"
    :model="form"
    :rules="rules"
    label-width="130px"
  >
    <el-form-item
      label="产品名称"
      prop="productName"
    >
      <el-input
        placeholder="产品名称"
        v-model="form.productName"
      ></el-input>
    </el-form-item>
    <el-form-item
      label="产品编码"
      prop="productCode"
    >
      <el-input
        placeholder="产品编码"
        v-model="form.productCode"
      ></el-input>
    </el-form-item>
    <el-form-item
      label="试用期限(天)"
      prop="trialPeriod"
    >
      <el-input
        v-model="form.trialPeriod"
        placeholder="试用期限"
        clearable
      ></el-input>
    </el-form-item>
    <el-form-item
      label="状态"
      prop="status"
    >
      <el-radio-group v-model="form.status">
        <el-radio :label="1">有效</el-radio>
        <el-radio :label="0">无效</el-radio>
      </el-radio-group>
    </el-form-item>
  </el-form>
</template>

<script>
let origin = {
  productName: '',
  productCode: '',
  trialPeriod: '',
  status: 1,
}
import formLabalPosition from "@/mixins/formLabalPosition";
export default {
  name: "productForm",
  props: {
    formData: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      form: JSON.parse(JSON.stringify(origin)),
      rules: {
        productName: [
          { required: true, message: '请输入产品名称', trigger: 'blur' },
          { max: 100, message: '产品名称最大长度为100', trigger: 'blur' }
        ],
        productCode: [
          { required: true, message: '请输入产品编码', trigger: 'blur' },
          { max: 100, message: '产品编码最大长度为100', trigger: 'blur' }
        ],
        trialPeriod: [
          {
            validator(rule, value, callback) {
              if (value === '' || value === null || value === undefined) {
                callback();
                return;
              }
              if (/^[1-9]\d*$/.test(String(value))) {
                callback();
                return;
              }
              callback(new Error('试用期限必须是正整数'));
            },
            trigger: ['blur', 'change']
          }
        ],
        status: [
          { required: true, message: '请选择状态', trigger: 'change' }
        ],
      },
    }
  },
  mixins: [formLabalPosition],
  methods: {
    reset() {
      this.form = JSON.parse(JSON.stringify(origin));
    },
    assigen(obj) {
      this.form.id = obj.id;
      this.form.productName = obj.productName;
      this.form.productCode = obj.productCode;
      this.form.trialPeriod = obj.trialPeriod === null || obj.trialPeriod === undefined ? '' : obj.trialPeriod;
      this.form.status = obj.status;
    },
    selfValidate() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$emit('submit', this.form);
        }
      })
    },
    selfClear() {
      this.$refs.form.clearValidate();
      this.$refs.form.resetFields();
      this.reset();
    },
  },
}
</script>

<style scoped>
@media screen and (max-width: 768px) {
  .authorize-product-form {
    /deep/ .el-form-item {
      margin-bottom: 26px;
    }
    /deep/ .el-form-item:last-child {
      margin-bottom: 0;
    }
  }
  /deep/ .el-form-item__label {
    float: none;
    display: block;
    width: 100%!important;
    padding: 0 0 8px;
    text-align: left;
    line-height: 1.4;
  }
  /deep/ .el-form-item__content {
    margin-left: 0!important;
  }
  /deep/ .el-radio-group {
    display: flex;
    flex-wrap: wrap;
    gap: 8px 16px;
  }
}
</style>
